export const _state = {
    isGetTasksFetch: false,
    isGetTaskFetch: false,
    isPostTaskFetch: false,
    isPutTaskFetch: false,
    isDeleteTaskFetch: false,
    errors: {},
    task: {},
    tasks: [],
};

export function tasksReducer(state = _state, action) {

    switch (action.type) {

        case 'CLEAR_TASKS':
            return {
                ...state,
                tasks: [],
            };

        case 'CLEAR_TASK_ERRORS':
            return {
                ...state,
                errors: {},
            };

        case 'API_GET_TASKS_CLOSE_FETCH':
            return {
                ...state,
                isGetTasksFetch: false,
            };

        case 'API_GET_TASK_CLOSE_FETCH':
            return {
                ...state,
                isGetTaskFetch: false,
            };

        case 'API_POST_TASK_CLOSE_FETCH':
            return {
                ...state,
                isPostTaskFetch: false,
            };

        case 'API_PUT_TASK_CLOSE_FETCH':
            return {
                ...state,
                isPutTaskFetch: false,
            };

        case 'API_DELETE_TASK_CLOSE_FETCH':
            return {
                ...state,
                isDeleteTaskFetch: false,
            };

        case 'API_GET_TASKS':
            return {
                ...state,
                isGetTasksFetch: true,
            };

        case 'API_GET_TASKS_SUCCESS':
            return {
                ...state,
                tasks: action.payload.data,
            };

        case 'API_GET_TASKS_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_CREATE_TASK':
            return {
                ...state,
                isPostTasksFetch: true,
            };

        case 'API_CREATE_TASK_SUCCESS':
            return {
                ...state,
                errors: {},
                task: action.payload.data,
            };

        case 'API_CREATE_TASK_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_UPDATE_TASK':
            return {
                ...state,
                isPutTasksFetch: true,
            };

        case 'API_GET_TASK':
            return {
                ...state,
                isGetTaskFetch: true,
            };

        case 'API_GET_TASK_SUCCESS':
            return {
                ...state,
                task: action.payload.data,
            };

        case 'API_GET_TASK_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_DELETE_TASK':
            return {
                ...state,
                isDeleteTaskFetch: true,
            };

        case 'API_DELETE_TASK_SUCCESS':
            return {
                ...state,
                task: {},
            };

        case 'API_DELETE_TASK_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'SET_EDIT_TASK':
            return {
                ...state,
                task: action.payload.task,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/tasks.js